import { resolveTenantOperationalHealth } from '../../utils/tenantOperationalHealth.js';

/**
 * Selo visual de saúde da empresa na lista admin.
 * @param {{ tenant: Record<string, unknown> }} props
 */
export function TenantOperationalBadge({ tenant }) {
  const health = resolveTenantOperationalHealth(tenant);
  const tone =
    health.level === 'operante'
      ? 'border-emerald-500/45 bg-emerald-500/15 text-emerald-900 dark:border-emerald-400/40 dark:bg-emerald-400/15 dark:text-emerald-50'
      : health.level === 'bloqueada'
        ? 'border-rose-500/50 bg-rose-500/15 text-rose-900 dark:border-rose-400/45 dark:bg-rose-500/20 dark:text-rose-100'
        : 'border-amber-500/50 bg-amber-500/15 text-amber-950 dark:border-amber-400/40 dark:bg-amber-500/15 dark:text-amber-50';
  const dot =
    health.level === 'operante'
      ? 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.7)]'
      : health.level === 'bloqueada'
        ? 'bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.65)]'
        : 'bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.6)]';

  const title =
    health.issues.length > 0
      ? `${health.label}: ${health.issues.join(' · ')}`
      : 'Empresa activa, sem bloqueio SaaS, ERP e canais críticos OK';

  return (
    <span
      className={`inline-flex max-w-full flex-col gap-1 rounded-xl border px-2 py-1 ${tone}`}
      title={title}
    >
      <span className="inline-flex items-center gap-1.5">
        <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${dot}`} aria-hidden />
        <span className="text-[10px] font-bold uppercase tracking-[0.14em]">{health.label}</span>
      </span>
      {health.issues.length > 0 ? (
        <span className="text-[10px] font-medium leading-snug opacity-90">
          {health.issues.slice(0, 2).join(' · ')}
          {health.issues.length > 2 ? ` · +${health.issues.length - 2}` : ''}
        </span>
      ) : null}
    </span>
  );
}
